import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/Button';
import { getDocumentAsDocx } from '@/lib/officeDoc';
import { uploadNewVersion } from '@/api/documents';

export function SavePane() {
  const { t } = useTranslation();
  const [fileId, setFileId] = useState('');
  const [status, setStatus] = useState<'idle' | 'saving' | 'ok' | 'error'>(
    'idle',
  );
  const [error, setError] = useState<string | null>(null);

  const onSave = async () => {
    setStatus('saving');
    setError(null);
    try {
      const buf = await getDocumentAsDocx();
      const filename = `lex-office-${Date.now()}.docx`;
      await uploadNewVersion(fileId, buf, filename);
      setStatus('ok');
    } catch (err) {
      setStatus('error');
      setError(err instanceof Error ? err.message : 'unknown');
    }
  };

  return (
    <div className="flex h-full flex-col gap-3 p-4">
      <input
        value={fileId}
        onChange={(e) => setFileId(e.target.value)}
        placeholder="ID de archivo en Lex Dataroom"
        className="w-full rounded-md border border-lex-slate-200 px-3 py-2 text-sm focus:border-lex-magenta focus:outline-none"
      />
      <Button onClick={onSave} disabled={!fileId || status === 'saving'}>
        {status === 'saving' ? t('common.loading') : t('save.cta')}
      </Button>
      {status === 'ok' ? (
        <p className="text-xs text-emerald-600">{t('save.success')}</p>
      ) : null}
      {status === 'error' ? (
        <p className="text-xs text-red-600">
          {t('save.error')}: {error}
        </p>
      ) : null}
    </div>
  );
}
